import FormFieldHelper from "../FormFieldHelper";
import FormFieldComponent from "./_FormFieldComponent";

export default class ShortAnswerFormFieldComponent extends FormFieldComponent {
    field;
    fieldAlias;

    constructor(el) {
        super(el);
        this.field = this.el.querySelector('[data-umb-field-alias]');
        this.fieldAlias = this.field.dataset.umbFieldAlias;

        const requiredValidator = FormFieldHelper.getRequiredFieldValidator(this.field);
        const briteVerifyValidator = FormFieldHelper.getBriteVerifyFieldValidator(this.field);
        const regexValidator = FormFieldHelper.getRegexFieldValidator(this.field);

        if (typeof (requiredValidator) !== 'undefined') {
            this.validators.push(requiredValidator);
        }

        if (typeof (briteVerifyValidator) !== 'undefined') {
            this.validators.push(briteVerifyValidator);
        }

        if (typeof (regexValidator) !== 'undefined') {
            this.validators.push(regexValidator);
        }
    }

    getValue() {
        return this.field.value;
    }

    getFieldAlias() {
        return this.fieldAlias;
    }
}